import React from 'react'
import Map from './Map'
import { useLocation } from 'react-router-dom'
import BottomMenu from '../components/BottomMenu'

const MapPage = () => {
  const location = useLocation();
  const { gameId } = location.state;
  const { teamId } = location.state;
  const { center } = location.state;

  return (
    <div className='my-6 max-w-6xl mx-auto'>
        <h1 className='text-2xl mb-3 mx-2 text-center'>マップ</h1>

        <div className='m-2'>
            <Map gameId={gameId} center={center} />
        </div>

        {/* 下部固定メニュー */}
        <BottomMenu gameId={gameId} teamId={teamId} />
    </div>
  )
}

export default MapPage